import { createContext, useContext } from "react";
import { type NotesTableContext as NotesTableContextType } from "../types";

export const NotesTableContext = createContext<NotesTableContextType | null>(null);

export const useNotesTableContext = () => {
  const context = useContext(NotesTableContext);
  if (!context) {
    throw new Error(
      "The hook 'useNotesTableService' must be used internally NotesTableContext Provider",
    );
  }
  return context;
};

export const useNotesTableDataFiltersService = (filterType: "date" | "dueDate") => {
  const context = useNotesTableContext();
  if (!context.dateFilters) return;
  return filterType === "date"
    ? context.dateFilters.dateFilters
    : context.dateFilters.dueDateFilters;
};
